import React, { Dispatch, FC, Fragment, useEffect, useState } from 'react'
import { BUDGETREFORTYPE, DataRefBudget, initialsumAnnuel, initialsummensuel, OtherArticle, profilsCanManagePotentielClientOperation, ROWTYPE, StyledTableRow, SUMANNUEL, SUMMENSUEL } from '../Budget/AddBudgetReforecastForm';
import { DataSaisieManager } from '../../content/production/SaisieAgent';
import { DataRef } from '../../../types/DataRef';
import { AxiosInstance } from 'axios';
import { ActionType, AlertType } from '../../../types/AlertType';
import { IYearsVerouillageClotureLocked } from '../../content/budget/ColumnHeader';
import { useStyles } from '../styles';
import { useSelector } from 'react-redux';
import { Reducers } from '../../../redux/reducers';
import UserInformation from '../../../types/UserInformation';
import { green } from '@mui/material/colors';
import CheckAttr from '../../../utils/CheckAttr';
import { AllMounth, MODE_BUDGET, MODE_PROD, PROFIL_MANAGER, PROFIL_SUPER_ADMIN, profilAllAccessBudgetSiVerouiller, yearsToDisplay } from '../../../constants/Constants';
import { profilsCanManageBudget, StyledTableCell } from '../../content/budget/Budget';
import { LoadingButton } from '@mui/lab';
import { Box, Grid, FormControl, InputLabel, Select, Button, Stack, Input, CircularProgress, Accordion, AccordionSummary, Typography, AccordionDetails, TextField, AccordionActions, TableContainer, Table, TableHead, TableRow, TableBody, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Backdrop, Slide, Paper } from '@mui/material';
import AddBudgetReforecastRowForm from '../Budget/AddBudgetReforecastRowForm';
import OtherArticleRow from '../Budget/OtherArticle/OtherArticleRow';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import CheckIcon from '@mui/icons-material/Check';
import SaveIcon from "@mui/icons-material/Save";
import { IYearsVerouillageClotureLockedReforcast } from '../../content/reforecast/tabs/tab2/ColumHeader';

interface OPERATION_BUDGET {
    operation: string;
    secteur_activite?: string;
    societeFacturation?: string;
}

interface OPERATION_BUDGET_ERROR_INPUT {
    operation: boolean;
    secteur_activite: boolean;
}

interface SaisieAgentFormProps {
    saisieAgent?: DataSaisieManager;
    dataPaysInAssociations: DataRef[];
    http: AxiosInstance;
    onClose: () => void;
    reloadList: (reloadMenuItem?: boolean) => void;
    setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
    setAlerteMessage: Dispatch<React.SetStateAction<string>>;
    setAlertType: Dispatch<React.SetStateAction<AlertType>>;
    dateVerrouillageCloture: IYearsVerouillageClotureLockedReforcast;
}

const initialOperationBudgetData: OPERATION_BUDGET = {
    operation: "",
    secteur_activite: "",
    societeFacturation: ""
};

const initialOperationBudgetErrorInput: OPERATION_BUDGET_ERROR_INPUT = {
    operation: false,
    secteur_activite: false
}

const AddReforecastForm: FC<SaisieAgentFormProps> = ({
    dataPaysInAssociations,
    http,
    onClose,
    reloadList,
    setOpenSnack,
    setAlerteMessage,
    setAlertType,
    dateVerrouillageCloture
}) => {
    const resetCoutToSave: BUDGETREFORTYPE = {
        pays: undefined,
        client: undefined,
        operation: undefined,
        month: undefined,
        year: undefined,
        rows: []
    };

    const classes = useStyles();

    const user = useSelector<Reducers>((state) => state.logger) as UserInformation;

    const [isClickSave, setIsClickSave] = useState<boolean>(false);

    const AllMounthFiltred = AllMounth.filter((month) => month.id >= 6);

    const [openClientBudgetDialog, setOpenClientBudgetDialog] = useState<boolean>(false);
    const [openOperationBudgetDialog, setOpenOperationBudgetDialog] = useState<boolean>(false);
    const [openOtherArticleDialog, setOpenOtherArticleDialog] = useState<boolean>(false);

    const [clientBudgetLoader, setClientBudgetLoader] = useState<boolean>(false);
    const [clientBudgetSuccess, setClientBudgetSuccess] = useState<boolean>(false);

    const [showClientBudgetInput, setShowClientBudgetInput] = useState<boolean>(false);
    const [showOperationBudgetInput, setShowOperationBudgetInput] = useState<boolean>(false);

    const [dataBusinessUnits, setDataBusinessUnit] = useState<DataRef[]>([]);
    const [dataSecteurActivites, setDataSecteurActivites] = useState<DataRef[]>([]);
    const [dataSocieteFacturations, setDataSocieteFacturations] = useState<DataRef[]>([]);
    const [dataTypes, setDataTypes] = useState<DataRef[]>([]);

    const [clientBudget, setClientBudget] = useState<string>("");
    const [operationBudget, setOperationBudget] = useState<OPERATION_BUDGET>(initialOperationBudgetData);
    const [operationBudgetLoader, setOperationBudgetLoader] = useState<boolean>(false);
    const [operationBudgetSuccess, setOperationBudgetSuccess] = useState<boolean>(false);

    const [clientBudgetErrorInput, setClientBudgetErrorInput] = useState<boolean>(false);
    const [operationBudgetErrorInput, setOperationBudgetErrorInput] = useState<OPERATION_BUDGET_ERROR_INPUT>(initialOperationBudgetErrorInput);

    const [showOtherArticleInput, setShowOtherArticleInput] = useState<boolean>(false);
    const [otherArticleSuccess, setOtherArticleSuccess] = useState<boolean>(false);
    const [otherArticleDatas, setOtherArticleDatas] = useState<OtherArticle[]>([]);
    const [otherArticleErrorInput, setOtherArticleErrorInput] = useState<string[]>([]);

    const [dataClients, setDataClients] = useState<DataRefBudget[]>([]);
    const [dataOperations, setDataOperations] = useState<DataRefBudget[]>([]);

    const [dataSumMensuel, setDataSumMensuel] = useState<SUMMENSUEL>(initialsummensuel);
    const [dataSumAnnuel, setDataSumAnnuel] = useState<SUMANNUEL>(initialsumAnnuel);
    const [budgetToSave, setBudgetToSave] = useState<BUDGETREFORTYPE>(resetCoutToSave);

    const [tabRowsError, setTabRowsError] = useState<string[]>([]);

    const [loader, setLoader] = useState<boolean>(false);
    const [count, setCount] = useState<number>(0);

    const clientMod = budgetToSave?.client ? budgetToSave?.client?.split('_')[0] : "";
    const operationMod = budgetToSave?.operation ? budgetToSave?.operation?.split('_')[0] : "";

    const buttonSxClient = {
        ...(clientBudgetSuccess ? {
            color: green[500],
            '&:hover': {
                color: green[700],
            }
        } : { color: 'warning' }),
        textTransform: 'none',
        mt: 2
    };

    const buttonSxOperation = {
        ...(operationBudgetSuccess ? {
            color: green[500],
            '&:hover': {
                color: green[700],
            }
        } : { color: 'warning' }),
        textTransform: 'none',
        mt: 2
    };

    const newRow: OtherArticle = {
        pays_id: budgetToSave?.pays,
        bu_id: null,
        type_id: null,
        has_budget: false
    };

    const getClients = async () => {
        setDataClients([]);

        let url = null;
        if (CheckAttr(budgetToSave?.pays)) {
            url = `client/get-clients-via-pays/${budgetToSave?.pays}`;
        } else {
            if (profilsCanManagePotentielClientOperation.includes(user?.profils?.libelle)) {
                url = 'client/get-clients-via-pays';
            }
        }

        if (url) {
            setLoader(true);
            await http.get(url).then((res) => {
                Array.isArray(res.data) && setDataClients(res.data);
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                setLoader(false);
            });
        }
    };

    const getAllSocieteFacturations = async () => {
        await http.get("societe-facturation/find/all")
            .then((res) => {
                Array.isArray(res.data) && setDataSocieteFacturations(res.data);
            }).catch((error) => {
                console.log(error);
            });
    }

    const getAllSecteurActivities = async () => {
        await http.get("secteur-activite/find/all")
            .then((res) => {
                Array.isArray(res.data) && setDataSecteurActivites(res.data);
            }).catch((error) => {
                console.log(error);
            });
    }

    const getAllBusinessUnits = async () => {
        await http.get('bu/find-all')
            .then((res) => {
                Array.isArray(res.data) && setDataBusinessUnit(res.data);
            }).catch((error) => {
                console.log(error);
            });
    }

    const getAllTypes = async () => {
        await http.get('getalltype')
            .then((res) => {
                Array.isArray(res.data) && setDataTypes(res.data);
            }).catch((error) => {
                console.log(error);
            });
    }

    useEffect(() => {
        // Recupère tous les clients
        getClients();

        // Recupère tous les societe de facturations
        getAllSocieteFacturations();

        // Recupère tous les secteurs d'activités
        getAllSecteurActivities();

        // Recupère tous les Bu
        getAllBusinessUnits();

        // Recupère tous les Types
        getAllTypes();
    }, []);

    useEffect(() => {
        setBudgetToSave({
            ...budgetToSave,
            client: '',
            clientMod: undefined,
            operation: undefined,
            operationMod: undefined,
            rows: []
        });

        setDataOperations([]);

        getClients();
    }, [budgetToSave?.pays]);

    useEffect(() => {
        setBudgetToSave({
            ...budgetToSave,
            operation: undefined,
            operationMod: undefined,
            rows: []
        });

        if (budgetToSave?.client) {
            setLoader(true);
            const splitedClientValue = budgetToSave?.client?.split('_');
            const data = {
                pays: budgetToSave?.pays,
                budget: splitedClientValue[0] === MODE_BUDGET,
                client: Number(splitedClientValue[1])
            };

            // Récupère les opérations du client sélectionné et pays sélectionné
            http.post('operation/get-operations/via-pays-client', data).then((res) => {
                Array.isArray(res.data) && setDataOperations(res.data);
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                setLoader(false);
            });
        }
    }, [budgetToSave?.client]);

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setBudgetToSave({
            ...budgetToSave,
            [name]: value,
        });
    };

    const handleChangeOperationBudgetData = (e: any) => {
        const { name, value } = e.target;

        setOperationBudget({
            ...operationBudget,
            [name]: value,
        });
    };

    const handleChangeRowsForBudget = (row: ROWTYPE, action: ActionType) => {
        let defaultRows = budgetToSave?.rows;

        if (action === "UPDATE") {
            // Si la ligne actuel à une difference sur l'original, alors la ligne est à enregistrer
            let toSaveVal = false;
            if ((row?.initial_ca_budget != row?.ca_budget) || (row?.initial_tx_marge_budget != row?.tx_marge_budget)) {
                toSaveVal = true;
            }

            const index = defaultRows.findIndex((c) => c.id === row.id);
            defaultRows[index] = { ...row, toSave: toSaveVal };
        }

        setBudgetToSave({
            ...budgetToSave,
            rows: defaultRows,
        });
    };

    useEffect(() => {
        if (
            CheckAttr(budgetToSave?.year) &&
            CheckAttr(budgetToSave?.month) &&
            CheckAttr(budgetToSave?.client) &&
            CheckAttr(budgetToSave?.operation)
        ) {
            setBudgetToSave({ ...budgetToSave, rows: [] });
            setLoader(true);
            // Récupère les opérations
            const decoupedClient = budgetToSave?.client?.split("_") as string[];
            const decoupedOperation = budgetToSave?.operation?.split("_") as string[];

            const data = {
                pays: budgetToSave?.pays,
                client: decoupedClient[1],
                clientMod: decoupedClient[0],
                operation: decoupedOperation[1],
                operationMod: decoupedOperation[0],
                year: budgetToSave?.year,
                month: String(budgetToSave?.month).padStart(2, "0"),
                model: 'Budget',
                rows: []
            }

            http.post("reforecast/get-rows-by-articles", data)
                .then((res) => {
                    setBudgetToSave({
                        ...budgetToSave,
                        rows: res.data.articles as ROWTYPE[]
                    });

                    setDataSumMensuel(res.data.totalDuMois as SUMMENSUEL);

                    setDataSumAnnuel(res.data.totalAnnee as SUMANNUEL);
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    setLoader(false);
                });
        } else {
            setBudgetToSave({
                ...budgetToSave,
                rows: [],
            });
        }
    }, [
        budgetToSave?.operation,
        budgetToSave?.year,
        budgetToSave?.month,
        otherArticleSuccess
    ]);

    useEffect(() => {
        if (CheckAttr(otherArticleDatas)) {
            setShowOtherArticleInput(true);
        } else {
            setShowOtherArticleInput(false);
        }
    }, [otherArticleDatas]);

    useEffect(() => {
        if (budgetToSave?.operation) {
            setLoader(true);
            const decoupedOperation = budgetToSave?.operation?.split("_") as string[];

            http.post("article/get-others", {
                operation: decoupedOperation[1],
                operationMod: decoupedOperation[0]
            }).then((res) => {
                if (Array.isArray(res.data)) {
                    const existRows = res.data as OtherArticle[];
                    setOtherArticleDatas((existRows?.length > 0) ? existRows : [newRow]);
                }
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                setLoader(false);
            });
        } else {
            setOtherArticleDatas([]);
        }

        setOtherArticleErrorInput([]);
    }, [budgetToSave?.operation, otherArticleSuccess]);

    const cleanData = () => {
        setTabRowsError([]);
        const tabErr: string[] = [];
        const finalData: ROWTYPE[] = [];

        budgetToSave?.rows?.forEach((budget) => {
            // Cas Profil MANAGER
            if (user?.profils?.libelle === PROFIL_MANAGER) {
                if ((CheckAttr(budget?.heure_ca_budget) || CheckAttr(budget?.acte_budget)) && CheckAttr(budget?.heure_cout_budget)) {
                    finalData.push(budget);
                } else {
                    if ((CheckAttr(budget?.heure_ca_budget) || CheckAttr(budget?.acte_budget)) || CheckAttr(budget?.heure_cout_budget)) {
                        if ((!CheckAttr(budget?.heure_ca_budget) && !CheckAttr(budget?.acte_budget))) {
                            tabErr.push(`${budget?.id} - 1`);
                            tabErr.push(`${budget?.id} - 2`);
                        }

                        !CheckAttr(budget?.heure_cout_budget) && tabErr.push(`${budget?.id} - 5`);
                    }
                }
            } else {
                // On verifie d'abord si tout les 5 champs CA budget, Taux marge budget, tarif et cout sont rempli
                if (CheckAttr(budget?.ca_budget) && CheckAttr(budget?.heure_cout_budget) && CheckAttr(budget?.cout_activite)) {
                    // Cas Profil DRC
                    if (profilsCanManageBudget.includes(user?.profils?.libelle)) {
                        // Et si, client et operation sont PROD, alors ils peuvent uniquement saisir les articles budget
                        if ((clientMod === MODE_PROD) && (operationMod === MODE_PROD)) {
                            (budget?.is_budget === 1) && finalData.push(budget);
                        } else {
                            finalData.push(budget);
                        }
                    } else {
                        finalData.push(budget);
                    }
                } else {
                    if (CheckAttr(budget?.heure_ca_budget) ||
                        CheckAttr(budget?.acte_budget) ||
                        CheckAttr(budget?.heure_cout_budget)) {
                        if (!CheckAttr(budget?.ca_budget)) {
                            if (CheckAttr(budget?.tarif_heure) || CheckAttr(budget?.tarif_acte)) {
                                if (CheckAttr(budget?.tarif_heure) && !CheckAttr(budget?.heure_ca_budget)) {
                                    tabErr.push(`${budget?.id} - 1`);
                                }

                                if (CheckAttr(budget?.tarif_acte) && !CheckAttr(budget?.acte_budget)) {
                                    tabErr.push(`${budget?.id} - 2`);
                                }
                            } else {
                                tabErr.push(`${budget?.id} - 3`);
                                tabErr.push(`${budget?.id} - 4`);
                            }
                        }

                        !CheckAttr(budget?.heure_cout_budget) && tabErr.push(`${budget?.id} - 5`);
                        !CheckAttr(budget?.cout_activite) && tabErr.push(`${budget?.id} - 6`);
                    }
                }
                // Validation des métriques de production
                const dmtReg = /^([0-9]{1,3}):[0-5][0-9](:[0-5][0-9])?$/;
                if (CheckAttr(budget?.dmt) && !dmtReg.test(String(budget?.dmt))) {
                    tabErr.push(`${budget?.id} - dmt`);
                }

                const isValidRate = (val: any) => {
                    if (!CheckAttr(val)) return true;
                    const num = Number(val);
                    return !isNaN(num) && num >= 0 && num <= 100;
                };

                if (!isValidRate(budget?.taux_occupation)) {
                    tabErr.push(`${budget?.id} - tx_occ`);
                }
                if (!isValidRate(budget?.taux_conges)) {
                    tabErr.push(`${budget?.id} - tx_cg`);
                }
                if (!isValidRate(budget?.taux_absenteisme)) {
                    tabErr.push(`${budget?.id} - tx_abs`);
                }
            }
        });

        if (tabErr.length > 0) {
            let validationMessage = "Merci de remplir les champs en rouge !";
            if (tabErr.some(x => x.includes("dmt"))) {
                validationMessage = "Format DMT incorrect (attendu: HH:MM:SS ou HH:MM) !";
            } else if (tabErr.some(x => x.includes("tx_"))) {
                validationMessage = "Les taux doivent être compris entre 0 et 100% !";
            }
            setAlerteMessage(validationMessage);
            setAlertType("warning");
            setOpenSnack(true);

            setTabRowsError(tabErr);

            return false;
        }

        if (finalData.length === 0) {
            setAlerteMessage("Merci de parametrer un budget parmi ceux qui sont encore vide SVP !");
            setAlertType("warning");
            setOpenSnack(true);

            return false;
        }

        return finalData;
    }

    const handleSave = () => {
        const finalBudgetToSave = cleanData();

        if (finalBudgetToSave !== false) {
            setIsClickSave(true);

            const datasToPost = {
                month: budgetToSave?.month,
                year: budgetToSave?.year,
                datas: finalBudgetToSave
            };

            http.post("reforecast/save", datasToPost).then(() => {
                setAlerteMessage("Enregistrement efféctuée !");
                setAlertType("success");
                setOpenSnack(true);
                // onClose();
                reloadList();
            }).catch((error) => {
                console.log(error);
                setAlertType("error");
                setOpenSnack(true);
            }).finally(() => {
                setIsClickSave(false);
            });
        }
    };

    const sumMensuelCaBudget = budgetToSave.rows.reduce((acc, curr) => acc + (Number(curr.ca_budget) || 0), 0);
    const sumMensuelMargeValeurBudget = budgetToSave.rows.reduce((acc, curr) => acc + (Number(curr.marge_valeur_budget) || 0), 0);

    const sumAnnuelCaBudget = (dataSumAnnuel?.totalAnneeCaBudget - dataSumMensuel?.totalDuMoisCaBudget) + sumMensuelCaBudget;
    const sumAnnuelMargeValeurBudget = (dataSumAnnuel?.totalAnneeMargeValeurBudget - dataSumMensuel?.totalDuMoisMargeValeurBudget) + sumMensuelMargeValeurBudget;

    let showOperations = false;
    if (CheckAttr(budgetToSave?.client) &&
        CheckAttr(budgetToSave?.operation) &&
        CheckAttr(budgetToSave?.year) &&
        CheckAttr(budgetToSave?.month) &&
        CheckAttr(budgetToSave?.rows)
    ) {
        showOperations = true;
    }

    const toggleClientBudgetInputVisibility = () => {
        const val = !showClientBudgetInput;
        if (val) {
            setClientBudgetSuccess(false);
        } else {
            setClientBudget("");
            setClientBudgetErrorInput(false);
        }

        setShowClientBudgetInput(val);
    };

    const toggleOperationBudgetInputVisibility = () => {
        const val = !showOperationBudgetInput;
        if (val) {
            setOperationBudgetSuccess(false);
        }

        setOperationBudgetErrorInput(initialOperationBudgetErrorInput);
        setOperationBudget(initialOperationBudgetData);
        setShowOperationBudgetInput(val);
    };

    const toggleOtherArticleInputVisibility = () => setShowOtherArticleInput(!showOtherArticleInput);

    const createClientBudget = () => {
        if (CheckAttr(clientBudget)) {
            setClientBudgetLoader(true);
            setClientBudgetErrorInput(false);
            http.post('client-budget/create', { libelle: clientBudget })
                .then(res => {
                    const newClientBudget = res.data.clientBudget as DataRefBudget;

                    // On ajoute le client potentiel fraichement crée dans la liste box
                    let tmpDataClient = dataClients;
                    tmpDataClient.push(newClientBudget);
                    setDataClients(tmpDataClient);

                    // On selectionne par default le client potentiel fraichement crée
                    setBudgetToSave({
                        ...budgetToSave,
                        client: `${MODE_BUDGET}_${newClientBudget?.id}`,
                        clientMod: MODE_BUDGET
                    });

                    setClientBudget("");
                    setClientBudgetSuccess(true);
                    setShowClientBudgetInput(false);
                }).catch(error => {
                    if (error.response.status === 409) {
                        setAlerteMessage(error.response.data as string);
                        setAlertType("warning");
                        setOpenSnack(true);
                    } else {
                        setAlertType("error");
                        setOpenSnack(true);
                    }

                    console.log(error);
                }).finally(() => {
                    setClientBudgetLoader(false);
                    setOpenClientBudgetDialog(false);
                });
        } else {
            setClientBudgetErrorInput(true);
        }
    }

    const createOperationBudget = () => {
        if (CheckAttr(operationBudget?.operation) && CheckAttr(operationBudget?.secteur_activite)) {
            setOperationBudgetLoader(true);
            setOperationBudgetErrorInput(initialOperationBudgetErrorInput);

            const splitedClientValue = budgetToSave?.client?.split('_') as string[];

            const data = {
                ...operationBudget,
                is_client_budget: splitedClientValue[0] === MODE_BUDGET,
                client: Number(splitedClientValue[1])
            };

            http.post('operation-budget/create', data)
                .then(res => {
                    const newOperationBudget = res.data.operationBudget as DataRefBudget;

                    // On ajoute le client potentiel fraichement crée dans la liste box
                    let tmpDataOperation = dataOperations;
                    tmpDataOperation.push(newOperationBudget);
                    setDataOperations(tmpDataOperation);

                    // On selectionne par default le client potentiel fraichement crée
                    setBudgetToSave({
                        ...budgetToSave,
                        operation: `${MODE_BUDGET}_${newOperationBudget?.id}`,
                        operationMod: MODE_BUDGET
                    });

                    setOperationBudget(initialOperationBudgetData);
                    setOperationBudgetSuccess(true);
                    setShowOperationBudgetInput(false);
                }).catch(error => {
                    if (error.response.status === 409) {
                        setAlerteMessage(error.response.data as string);
                        setAlertType("warning");
                        setOpenSnack(true);
                    } else {
                        setAlertType("error");
                        setOpenSnack(true);
                    }

                    console.log(error);
                }).finally(() => {
                    setOperationBudgetLoader(false);
                    setOpenOperationBudgetDialog(false);
                });
        } else {
            if (!CheckAttr(operationBudget?.operation)) {
                setOperationBudgetErrorInput((prev: OPERATION_BUDGET_ERROR_INPUT) => ({ ...prev, operation: true }));
            }

            if (!CheckAttr(operationBudget?.secteur_activite)) {
                setOperationBudgetErrorInput((prev: OPERATION_BUDGET_ERROR_INPUT) => ({ ...prev, secteur_activite: true }));
            }
        }
    }

    if (clientBudgetSuccess) {
        setTimeout(() => {
            setClientBudgetSuccess(false);
        }, 2000);
    }

    /**
     * Vérifie si un champ est vide
     * @returns 
     */
    const checkEmptyValue = (): boolean => {
        let errorInputNames: string[] = [];
        otherArticleDatas.forEach((element, index) => {
            (!element?.pays_id) && errorInputNames.push(`pays_id_${index}`);
            (!element?.bu_id) && errorInputNames.push(`bu_id_${index}`);
            (!element?.article_libelle) && errorInputNames.push(`article_libelle_${index}`);
            (!element?.type_id) && errorInputNames.push(`type_id_${index}`);
        });

        if (errorInputNames.length > 0) {
            setOtherArticleErrorInput(errorInputNames);

            setAlerteMessage("Merci de remplir les champs en rouge !");
            setAlertType("warning");
            setOpenSnack(true);

            return false;
        }

        return true;
    }

    /**
     * Vérification doublons
     * @returns 
     */
    const checkDoublonsCombinaison = () => {
        let result = true;
        let doublonsRows: string[] = [];
        for (let index = 0; index < otherArticleDatas.length; index++) {
            const element = otherArticleDatas[index];

            if (!CheckAttr(element?.deleted)) {
                const value = `${element?.pays_id}-${element?.bu_id}-${element?.article_libelle?.trim().toUpperCase()}-${element?.type_id}`;
                if (doublonsRows.includes(value)) {
                    let errorInputNames: string[] = [];

                    // Ligne qui existe déja
                    const existIndex = doublonsRows.findIndex(elem => elem === value);
                    errorInputNames.push(`pays_id_${existIndex}`);
                    errorInputNames.push(`bu_id_${existIndex}`);
                    errorInputNames.push(`article_libelle_${existIndex}`);
                    errorInputNames.push(`type_id_${existIndex}`);

                    // Ligne actuel
                    errorInputNames.push(`pays_id_${index}`);
                    errorInputNames.push(`bu_id_${index}`);
                    errorInputNames.push(`article_libelle_${index}`);
                    errorInputNames.push(`type_id_${index}`);

                    setOtherArticleErrorInput(errorInputNames);

                    setAlerteMessage("Désolé ! Les lignes en rouge sont en double !");
                    setAlertType("warning");
                    setOpenSnack(true);

                    result = false;
                    break;
                } else {
                    doublonsRows.push(value)
                }
            }
        }

        return result;
    };

    const isValidate = () => {
        setOtherArticleErrorInput([]);
        if (checkEmptyValue() && checkDoublonsCombinaison()) {
            setOpenOtherArticleDialog(true)
        }
    }

    const createOtherArticle = async () => {
        setLoader(true);
        setOpenOtherArticleDialog(false);

        const splitedOperationValue = budgetToSave?.operation?.split('_') as string[];

        const data = {
            is_operation_budget: splitedOperationValue[0] === MODE_BUDGET,
            operation: Number(splitedOperationValue[1]),
            rows: otherArticleDatas
        };

        await http.post('article/save-all-other-rows', data)
            .then(res => {
                setAlerteMessage("Enrégistrement article Effectué !");
                setAlertType("success");
                setOpenSnack(true);
                setOtherArticleSuccess(!otherArticleSuccess);
            }).catch(error => {
                console.log(error);
                setAlertType("error");
                setOpenSnack(true);
            }).finally(() => {
                setLoader(false);
            });
    };

    if (operationBudgetSuccess) {
        setTimeout(() => {
            setOperationBudgetSuccess(false);
        }, 2000);
    }

    let yearsItems = yearsToDisplay;

    // Si Profil n'est Pas ADV, Super Admin on block l'anne Verouille Si L'anne est Verouillé
    if ((!profilAllAccessBudgetSiVerouiller.includes(user?.profils?.libelle))) {
        // yearsItems= yearsItems.filter((y) => y !== dateVerrouillageCloture?.DateVerouillageBudget?.annee)
        yearsItems = yearsItems.filter(number => !dateVerrouillageCloture?.YearsVerouillageReforcast.includes(number));
    }

    // Si Profil n'est Pas SA on block l'anne Cloturé Si L'anne est Cloturée
    if ((![PROFIL_SUPER_ADMIN].includes(user?.profils?.libelle))) {
        // yearsItems= yearsItems.filter((y) => y !== dateVerrouillageCloture?.DateClotureBudget?.annee)
        yearsItems = yearsItems.filter(number => !dateVerrouillageCloture?.YearsClotureReforcast.includes(number));
    }

    const handleChangeArticleAutre = (e: any, i: number) => {
        const { name, value } = e.target;

        let tmpArticlesAutres = otherArticleDatas;
        const newValues = tmpArticlesAutres?.map((elem, index) => ((index === i) ? { ...elem, [name]: value } : elem));

        setOtherArticleDatas(newValues);
    };

    const handleAddRow = () => {
        let allOtherArticleRows = otherArticleDatas;
        allOtherArticleRows.push(newRow);

        setOtherArticleDatas(allOtherArticleRows);
        setCount(count + 1);
    };

    const handleRemoveRow = (i: number) => {
        let allOtherArticleRows: OtherArticle[] = [];
        otherArticleDatas.forEach((element, index) => {
            if (index === i) {
                element?.article_id && allOtherArticleRows.push({ ...element, deleted: true });
            } else {
                allOtherArticleRows.push(element);
            }
        });

        setOtherArticleDatas(allOtherArticleRows);
        setCount(count - 1);
    };

    return (
        <Fragment>
            <Box className={classes.root} mb={3}>
                <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
                    <Grid item xs={6} sm={12} md={12}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            sx={{ marginLeft: 1, marginTop: 1 }}
                        >
                            <InputLabel
                                htmlFor="pays"
                                color="warning"
                                shrink={CheckAttr(budgetToSave?.pays)}
                            >
                                Pays de production
                            </InputLabel>
                            <Select
                                id="pays"
                                native
                                color="warning"
                                value={budgetToSave?.pays}
                                onChange={handleChange}
                                label="Pays de production"
                                inputProps={{
                                    name: "pays",
                                }}
                            >
                                <option value=""></option>
                                {dataPaysInAssociations.map((pays) => (
                                    <option key={pays?.id} value={pays?.id}>
                                        {pays?.libelle}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={6} sm={12} md={12}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            sx={{ marginLeft: 1, marginTop: 1 }}
                        >
                            <InputLabel
                                htmlFor="client"
                                color="warning"
                                shrink={CheckAttr(budgetToSave?.client)}
                            >
                                Client
                            </InputLabel>
                            <Select
                                id="client"
                                native
                                color="warning"
                                value={budgetToSave?.client}
                                onChange={handleChange}
                                label="Client"
                                inputProps={{
                                    name: "client",
                                }}
                            >
                                <option value=""></option>
                                {dataClients.map((client) => (
                                    <option key={client?.id} value={client?.budget ? `budget_${client?.id}` : `prod_${client?.id}`}>
                                        {client?.libelle}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {profilsCanManagePotentielClientOperation.includes(user?.profils?.libelle) ? (
                        <Grid item xs={6} sm={2} md={2}>
                            <Button
                                variant="contained"
                                color="inherit"
                                size="small"
                                fullWidth
                                sx={{ textTransform: 'none', my: 2 }}
                                disabled={CheckAttr(budgetToSave?.client)}
                                onClick={() => toggleClientBudgetInputVisibility()}
                            >
                                Client potentiel
                            </Button>
                        </Grid>
                    ) : null}

                    <Grid item xs={6} sm={10} md={10}>
                        <Slide direction="down" in={showClientBudgetInput} mountOnEnter unmountOnExit>
                            <Stack direction="row" display="flex" justifyContent="space-between" mt={2}>
                                <FormControl variant="standard" color="warning" sx={{ minWidth: 320 }}>
                                    <Input
                                        id="standard-adornment-password"
                                        size="small"
                                        placeholder="Veuillez saisir le nom du client budget ..."
                                        autoComplete="off"
                                        error={clientBudgetErrorInput}
                                        value={clientBudget}
                                        disabled={clientBudgetLoader || clientBudgetSuccess}
                                        onChange={(e) => setClientBudget(e.target.value)}
                                    />
                                </FormControl>

                                <Box mt={-2.5}>
                                    <Button
                                        variant="text"
                                        color="warning"
                                        sx={buttonSxClient}
                                        disabled={clientBudgetLoader}
                                        onClick={() => setOpenClientBudgetDialog(true)}
                                    >
                                        {clientBudgetSuccess ? 'Enregistré ...' : 'Ajouter'}
                                    </Button>
                                    {clientBudgetLoader && (
                                        <CircularProgress
                                            size={24}
                                            sx={{
                                                color: green[500],
                                                position: 'absolute',
                                                top: '65%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </Box>
                            </Stack>
                        </Slide>
                    </Grid>

                    <Grid item xs={6} sm={12} md={12}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            sx={{ marginLeft: 1, marginTop: 1 }}
                        >
                            <InputLabel
                                htmlFor="operation"
                                color="warning"
                                shrink={CheckAttr(budgetToSave?.operation)}
                            >
                                Opération
                            </InputLabel>
                            <Select
                                id="operation"
                                native
                                color="warning"
                                value={budgetToSave?.operation}
                                onChange={handleChange}
                                label="Opération"
                                inputProps={{
                                    name: "operation",
                                }}
                            >
                                <option value=""></option>
                                {dataOperations.map((operation) => (
                                    <option key={operation?.id} value={operation?.budget ? `budget_${operation?.id}` : `prod_${operation?.id}`}>
                                        {operation?.libelle}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

                {profilsCanManagePotentielClientOperation.includes(user?.profils?.libelle) ? (
                    <Box sx={{ width: '100%', mt: 2, ml: 1 }}>
                        <Accordion
                            expanded={showOperationBudgetInput}
                            onChange={() => toggleOperationBudgetInputVisibility()}
                            disabled={CheckAttr(budgetToSave?.operation) || !CheckAttr(budgetToSave?.client)}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography>Opération potentielle</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={4} columns={{ xs: 6, sm: 12, md: 12 }}>
                                    <Grid item xs={4} sm={3.5} md={3.5}>
                                        <TextField
                                            color="warning"
                                            variant="standard"
                                            size="small"
                                            name="operation"
                                            label="libelle"
                                            autoComplete="off"
                                            value={operationBudget?.operation}
                                            error={operationBudgetErrorInput?.operation}
                                            onChange={handleChangeOperationBudgetData}
                                            InputLabelProps={{
                                                shrink: CheckAttr(operationBudget?.operation),
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={4} sm={3.5} md={3.5}>
                                        <FormControl
                                            variant="standard"
                                            className={classes.formControl}
                                        >
                                            <InputLabel
                                                htmlFor="secteur_activite"
                                                color="warning"
                                                shrink={CheckAttr(operationBudget?.secteur_activite)}
                                            >
                                                Secteur d’activité
                                            </InputLabel>
                                            <Select
                                                id="secteur_activite"
                                                native
                                                color="warning"
                                                size="small"
                                                value={operationBudget?.secteur_activite}
                                                error={operationBudgetErrorInput?.secteur_activite}
                                                onChange={handleChangeOperationBudgetData}
                                                label="Secteur d’activité"
                                                inputProps={{
                                                    name: "secteur_activite",
                                                }}
                                            >
                                                <option value=""></option>
                                                {dataSecteurActivites.map((secteur) => (
                                                    <option key={secteur?.id} value={secteur?.id}>
                                                        {secteur?.libelle}
                                                    </option>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={4} sm={3.5} md={3.5}>
                                        <FormControl
                                            variant="standard"
                                            className={classes.formControl}
                                        >
                                            <InputLabel
                                                htmlFor="societeFacturation"
                                                color="warning"
                                                shrink={CheckAttr(operationBudget?.societeFacturation)}
                                            >
                                                Société de facturation
                                            </InputLabel>
                                            <Select
                                                id="societeFacturation"
                                                native
                                                color="warning"
                                                size="small"
                                                value={operationBudget?.societeFacturation}
                                                onChange={handleChangeOperationBudgetData}
                                                label="Société de facturation"
                                                inputProps={{
                                                    name: "societeFacturation",
                                                }}
                                            >
                                                <option value=""></option>
                                                {dataSocieteFacturations.map((societe) => (
                                                    <option key={societe?.id} value={societe?.id}>
                                                        {societe?.libelle}
                                                    </option>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={4} sm={1.5} md={1.5}>
                                        <Box sx={{ position: 'relative' }}>
                                            <Button
                                                variant="text"
                                                color="warning"
                                                sx={buttonSxOperation}
                                                disabled={operationBudgetLoader}
                                                onClick={() => setOpenOperationBudgetDialog(true)}
                                            >
                                                {operationBudgetSuccess ? 'Enregistré ...' : 'Ajouter'}
                                            </Button>
                                            {operationBudgetLoader && (
                                                <CircularProgress
                                                    size={24}
                                                    sx={{
                                                        color: green[500],
                                                        position: 'absolute',
                                                        top: '65%',
                                                        left: '30%',
                                                        marginTop: '-12px',
                                                        marginLeft: '-12px',
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                ) : null}

                <Box sx={{ width: '100%', mt: 2, ml: 1 }}>
                    <Accordion
                        expanded={showOtherArticleInput}
                        onChange={toggleOtherArticleInputVisibility}
                        disabled={!CheckAttr(budgetToSave?.operation)}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Typography>Article autre</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {otherArticleDatas.map((row, index) => (
                                !row?.deleted ? (
                                    <OtherArticleRow
                                        key={index}
                                        index={index}
                                        dataPaysInAssociations={dataPaysInAssociations}
                                        dataBusinessUnits={dataBusinessUnits}
                                        dataTypes={dataTypes}
                                        row={row}
                                        articlesAutres={otherArticleDatas}
                                        otherArticleErrorInput={otherArticleErrorInput}
                                        handleChangeArticleAutre={handleChangeArticleAutre}
                                        handleRemoveRow={handleRemoveRow}
                                    />
                                ) : null
                            ))}
                        </AccordionDetails>
                        <AccordionActions>
                            <Button
                                size="small"
                                sx={{ textTransform: 'none' }}
                                onClick={() => handleAddRow()}
                            >
                                Ajouter une ligne
                            </Button>
                            <Button
                                size="small"
                                sx={{ textTransform: 'none' }}
                                disabled={operationBudgetLoader || !CheckAttr(otherArticleDatas)}
                                onClick={() => isValidate()}
                            >
                                Enregistrer
                            </Button>
                        </AccordionActions>
                    </Accordion>
                </Box>

                <Box mt={7}>
                    <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
                        <Grid item xs={6} sm={6} md={6}>
                            <FormControl
                                variant="outlined"
                                className={classes.formControl}
                                sx={{ marginLeft: 1, marginTop: 1 }}
                            >
                                <InputLabel
                                    htmlFor="year"
                                    color="warning"
                                    shrink={CheckAttr(budgetToSave?.year)}
                                >
                                    Année
                                </InputLabel>
                                <Select
                                    id="year"
                                    native
                                    color="warning"
                                    value={budgetToSave?.year}
                                    onChange={handleChange}
                                    label="Année"
                                    inputProps={{
                                        name: "year",
                                    }}
                                >
                                    <option value={0}></option>
                                    {yearsItems.map((year) => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6}>
                            <FormControl
                                variant="outlined"
                                className={classes.formControl}
                                sx={{ marginLeft: 1, marginTop: 1 }}
                            >
                                <InputLabel
                                    htmlFor="month"
                                    color="warning"
                                    shrink={CheckAttr(budgetToSave?.month)}
                                >
                                    Mois
                                </InputLabel>
                                <Select
                                    id="month"
                                    native
                                    color="warning"
                                    value={budgetToSave?.month}
                                    onChange={handleChange}
                                    label="Mois"
                                    inputProps={{
                                        name: "month",
                                    }}
                                >
                                    <option value=""></option>
                                    {AllMounthFiltred.map((month) => (
                                        <option key={month?.id} value={month?.id}>
                                            {month?.mounth}
                                        </option>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            {showOperations && (
                 <>
                    <TableContainer sx={{ mt: 2 ,minWidth: 700 , maxHeight: 480 }}>
                        <Table stickyHeader aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell />
                                    <StyledTableCell />
                                    <StyledTableCell />
                                    <StyledTableCell />
                                    <StyledTableCell colSpan={4}>Saisie CA Budget</StyledTableCell>
                                    <StyledTableCell />
                                    <StyledTableCell colSpan={5}>Saisie Coût Budget</StyledTableCell>
                                    <StyledTableCell colSpan={4}>Saisie métriques de production</StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCell>
                                        Business unit
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        Type
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        Codes article
                                    </StyledTableCell>
                                    <StyledTableCell >
                                        Articles / Désignation
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Box width={60}>Heure Budget</Box>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Box width={60}>Acte budget</Box>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        PU Heure
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        PU Acte
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        CA Budget
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        Heure Coût Budget
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        Coût/h
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        Coût Budget
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Box width={70}>Marge valeur budget</Box>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Box width={60}>Taux marge budget</Box>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Box width={80}>DMT</Box>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Box width={80}>Taux occupation (%)</Box>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Box width={80}>Taux congés (%)</Box>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Box width={80}>Taux absentéisme (%)</Box>
                                    </StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {budgetToSave.rows.map((article) => (
                                    <AddBudgetReforecastRowForm
                                        key={article.id}
                                        profil={user?.profils?.libelle}
                                        clientMod={clientMod}
                                        operationMod={operationMod}
                                        article={article}
                                        tabRowsError={tabRowsError}
                                        handleChangeRowsForBudget={handleChangeRowsForBudget}
                                    />
                                ))}
                                <StyledTableRow>
                                    <StyledTableCell colSpan={18} />
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell colSpan={3}>Total du mois</StyledTableCell>
                                    <StyledTableCell colSpan={5} />
                                    <StyledTableCell>
                                        {sumMensuelCaBudget && parseFloat(String(sumMensuelCaBudget))?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell colSpan={4} />
                                    <StyledTableCell>
                                        {sumMensuelMargeValeurBudget && parseFloat(String(sumMensuelMargeValeurBudget))?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell colSpan={4} />
                                </StyledTableRow>

                                <StyledTableRow>
                                    <StyledTableCell colSpan={3}>Total de l’année</StyledTableCell>
                                    <StyledTableCell colSpan={5} />
                                    <StyledTableCell>
                                        {sumAnnuelCaBudget && parseFloat(String(sumAnnuelCaBudget))?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell colSpan={4} />
                                    <StyledTableCell>
                                        {sumAnnuelMargeValeurBudget && parseFloat(String(sumAnnuelMargeValeurBudget))?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell colSpan={4} />
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box display="flex" justifyContent="center" mt={5}>
                        <LoadingButton
                            onClick={() => handleSave()}
                            endIcon={<SaveIcon />}
                            loading={isClickSave}
                            loadingPosition="end"
                            sx={{ textTransform: "none" }}
                            variant="contained"
                            color="warning"
                        >
                            Enregistrer
                        </LoadingButton>
                    </Box>
                </>
            )}

            <Dialog
                open={openClientBudgetDialog}
                keepMounted
                onClose={() => setOpenClientBudgetDialog(false)}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Creation client budget</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Voulez-vous vraiment créé ce Client budget ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        onClick={() => createClientBudget()}
                        endIcon={<CheckIcon />}
                        loading={clientBudgetLoader}
                        loadingPosition="end"
                        sx={{ textTransform: "none" }}
                        variant="contained"
                        color="warning"
                        size="small"
                    >
                        Oui
                    </LoadingButton>
                    <Button
                        onClick={(e) => setOpenClientBudgetDialog(false)}
                        variant="contained"
                        color="inherit"
                        sx={{ textTransform: "none" }}
                        startIcon={<ExitToAppIcon />}
                        size="small"
                    >
                        Non
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openOperationBudgetDialog}
                keepMounted
                onClose={() => setOpenOperationBudgetDialog(false)}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Creation opération budget</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Voulez-vous vraiment créé cet opération budget ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        onClick={() => createOperationBudget()}
                        endIcon={<CheckIcon />}
                        loading={operationBudgetLoader}
                        loadingPosition="end"
                        sx={{ textTransform: "none" }}
                        variant="contained"
                        color="warning"
                        size="small"
                    >
                        Oui
                    </LoadingButton>
                    <Button
                        onClick={(e) => setOpenOperationBudgetDialog(false)}
                        variant="contained"
                        color="inherit"
                        sx={{ textTransform: "none" }}
                        startIcon={<ExitToAppIcon />}
                        size="small"
                    >
                        Non
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openOtherArticleDialog}
                keepMounted
                onClose={() => setOpenOtherArticleDialog(false)}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Creation Article autre</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Voulez-vous vraiment enregistrer ces articles autre ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="warning"
                        size="small"
                        endIcon={<CheckIcon />}
                        sx={{ textTransform: "none" }}
                        onClick={() => createOtherArticle()}
                    >
                        Oui
                    </Button>
                    <Button
                        onClick={(e) => setOpenOtherArticleDialog(false)}
                        variant="contained"
                        color="inherit"
                        sx={{ textTransform: "none" }}
                        startIcon={<ExitToAppIcon />}
                        size="small"
                    >
                        Non
                    </Button>
                </DialogActions>
            </Dialog>

            <div>
                <Backdrop
                    sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loader}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </Fragment>
    );
};

export default AddReforecastForm;